"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = search;
function search() {
  return {
    all: searcher.bind(this, "/search"),

    photos: searcher.bind(this, "/search/photos"),

    users: searcher.bind(this, "/search/users"),

    collections: searcher.bind(this, "/search/collections")
  };
}

function searcher(url) {
  var keyword = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
  var page = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  var query = {
    query: keyword,
    page: page
  };

  return this.request({
    url: url,
    method: "GET",
    query: query
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/unsplash-js/lib/methods/search.js
 ** module id = 526
 ** module chunks = 0
 **/